import React from 'react';
import { injectIntl } from 'react-intl';
import SlickCarousel from 'src/components/SlickCarousel';
import avatarOne  from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage01.webp';
import avatarTwo from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage02.webp';
import avatarThree from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage03.webp';
import avatarFour from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage04.webp';
import avatarSix from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage06.webp';
import avatarSeven  from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage07.webp';
import avatarEight from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage08.webp';
import avatarNine from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage09.webp';
import avatarTen  from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage10.webp';
import avatarEleven  from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage11.webp';
import avatarTwelve  from 'src/layouts/unauthorized/Login/images/LoginPageAvatarImage12.webp';


const DEFAULT_SETTINGS = {
  dots: false,
  fade: true,
  infinite: true,
  speed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: false,
  autoplaySpeed: 7000,
  arrows: false,
};

const UnauthorizedCarousel = (props: any) => {
  const { intl } = props;
  return <SlickCarousel
    images={[avatarOne,avatarTwo, avatarThree, avatarFour, avatarSix,avatarSeven ,avatarEight, avatarNine,avatarTen, avatarEleven, avatarTwelve]}
    alt={intl.formatMessage({ id: 'MursionPortal.AltText.MursionDashboard' })}
    id="slide"
    settings={DEFAULT_SETTINGS}
  />;
};

export default injectIntl(UnauthorizedCarousel);
